import React from 'react';

import Image from '../../library/image/image';

import './snowy-road.scss';

function SnowyRoad() {
  return (
    <div styleName="container">
      <Image
        alt="Snowy Road Image"
        src="https://discounttire.scene7.com/is/content/discounttire/treadwell/treadwell_squiggly_snowy_road.svg"
      />
    </div>
  );
}

export default SnowyRoad;
